var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16111 10.4653H8.33615M15 10.4653H15.175M21.6619 10.4653H21.8369M14.25 16.5403H5.66667C4.19391 16.5403 3 15.4657 3 14.1403V6.79026C3 5.46478 4.19391 4.39026 5.66667 4.39026H24.3333C25.8061 4.39026 27 5.46478 27 6.79026V10.4653M19.264 15.2972L21.0015 14.5153C22.2684 13.9452 23.7596 13.9452 25.0264 14.5153L26.764 15.2972C26.764 15.2972 26.764 17.761 26.764 19.0603C26.764 20.3597 25.4294 21.2368 23.014 22.6097C20.5986 21.2368 19.264 20.0785 19.264 19.0603V15.2972Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordChange);
export default __webpack_public_path__ + "static/media/password-change.fb93a21482fc883691d0b6fe42db61cc.svg";
export { ForwardRef as ReactComponent };